import React, {Component} from 'react';
import {scroller} from "react-scroll";
import $ from 'jquery';
import {AJAX, hidePreloader, showPreloader} from "../functions";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {getRentalCarPrices, gTagClickEventValue} from "./frontend_script";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import {DateComponent, TimeComponent} from "./DateComponent";
import {getCurrentMinDate, getDisabledHours,getDefaultStartTime, getDefaultEndTime, getDefaultEndDate} from "./Utils";
import moment from "moment";

let _pick_up = null, _drop_off = null;

class SearchFormInterstatePage extends Component {

	constructor(props) {
		super(props);
		this.onChangePickup = this.onChangePickup.bind(this);
		this.onChangePickupInput = this.onChangePickupInput.bind(this);
		this.onChangeReturn = this.onChangeReturn.bind(this);
		this.onChangeReturnInput = this.onChangeReturnInput.bind(this);
		this.onChangeTrip = this.onChangeTrip.bind(this);
		this.onChangeDates = this.onChangeDates.bind(this);
		this.getSearchAjax = this.getSearchAjax.bind(this);
		this.onBlurHandler = this.onBlurHandler.bind(this);
		this.onChangeVehicleGroup = this.onChangeVehicleGroup.bind(this);
    	this.onChangeEmailInput = this.onChangeEmailInput.bind(this);

		const book_data = this.props.booking_form_data.booking?this.props.booking_form_data.booking : {};

		let formats_date = ["DD-MM-YYYY", "DD/MM/YYYY", "DD/MMM/YYYY"];
		let formats_time = ["hh:mm A"];

		let _fromDate = book_data.pickup_date &&  moment(book_data.pickup_date, formats_date, true).isValid() ? moment(book_data.pickup_date, formats_date) : null,
			_fromTime =  book_data.pickup_time &&  moment(book_data.pickup_time, formats_time, true).isValid() ? moment(book_data.pickup_time, formats_time) : null,
			_toDate = book_data.return_date &&  moment(book_data.return_date, formats_date, true).isValid() ? moment(book_data.return_date, formats_date) : null,
			_toTime = book_data.return_time &&  moment(book_data.return_time, formats_time, true).isValid() ? moment(book_data.return_time, formats_time) : null;


		this.state = {
			/*dates and times*/
			first_open_calendar: false, // false - init calendar, true - first open

			fromDate: _fromDate, // if not null then is moment instance
			toDate: _toDate,   // if not null then is moment instance
			fromTime: _fromTime, //from that we will need only times, if not null, then is moment instance
			toTime: _toTime, // from that we will need only times, if not null, then is moment instance

			return_location_show: this.props.booking_form_data.booking.pickup_location !== undefined ? true : false,
			trip_show: this.props.booking_form_data.booking.return_location !== undefined ? true : false,
			dates_show: this.props.booking_form_data.booking.return_in_different !== undefined ? true : false,
			button_show: this.props.booking_form_data.booking.return_in_different !== undefined ? true : false,
			// form data
			pickup_location: this.props.booking_form_data.booking.pickup_location !== undefined ? this.props.booking_form_data.booking.pickup_location : "",
			return_location: this.props.booking_form_data.booking.return_location !== undefined ? this.props.booking_form_data.booking.return_location : "",
			pickup_location_state: "",
			return_location_state: "",
			return_in_different: this.props.booking_form_data.booking.return_in_different !== undefined ? this.props.booking_form_data.booking.return_in_different : "0",

			pickup_date: "",
			pickup_time: "",
			return_date: "",
			return_time: "",

      		interstate_email: this.props.booking_form_data.booking.interstate_email !== undefined ? this.props.booking_form_data.booking.interstate_email:'',
      		interstate_phone: this.props.booking_form_data.booking.interstate_phone !== undefined ? this.props.booking_form_data.booking.interstate_phone:'',
			campaigncode: this.props.booking_form_data.booking.campaigncode !== undefined ? this.props.booking_form_data.booking.campaigncode : "",
			category_group_filter: this.props.category_group_filter,
			//output on page
			to_show: {
				kms: "",
				pickup: "",
				return: ""
			},
			search_result: {
				'success': 0,
				'vehicles': {}
			},
			search_result_filter: {
				'vehicles': {}
			},
			pickup_locationError: '',
			pickup_locationDirty: false,
			return_locationError: '',
			return_locationDirty: false,
			return_in_differentError: this.props.booking_form_data.booking.return_in_different === undefined ? 'Please select a trip.' : '',
			return_in_differentDirty: false,
			pickup_dateError: 'This field is required.',
			pickup_dateDirty: false,
			pickup_timeError: 'This field is required.',
			pickup_timeDirty: false,
			return_dateError: 'This field is required.',
			return_dateDirty: false,
			return_timeError: 'This field is required.',
			return_timeDirty: false,
			interstate_emailError: this.props.booking_form_data.booking.interstate_email !== undefined ? '' : 'This field is required.',
			interstate_emailDirty: false,
			interstate_phoneError: this.props.booking_form_data.booking.interstate_phone !== undefined ? '' : 'This field is required.',
			interstate_phoneDirty: false,
			validate: false
		};
	}
  	onChangeEmailInput(e) {
    let nameError = e.target.name + 'Error';
    if (e.target.value.length > 0) {
      this.setState({[nameError]: ''});
      if (e.target.name === 'interstate_email') {
        const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (!re.test(String(e.target.value).toLowerCase()))
          this.setState({[nameError]: 'Please enter a valid email address.'});
      }
	  if (e.target.name === 'interstate_phone') {
			const re2 = /^(\+6\d{10}|0\d{9})$/;
			if (!re2.test(e.target.value)) {
				this.setState({[nameError]: 'Please enter a valid phone number'});
			}
		}
    }
    else {
      this.setState({[nameError]: 'This field is required.'});
    }
  }
	createLocations() {
		let t = this;
		const options = {types: ['(cities)'], componentRestrictions: {country: "au"}};

		let pick_up_el = $('#pickup_location_id')[0], drop_off_el = $('#return_location_id')[0];

		let _pick_up_Lsr = null, _drop_off_Lsr =  null;
		let drop_timeout, pick_timeout;

		$(pick_up_el).focus(function (e) {
			$(this).data('old-value',$(this).val());
			if (!_pick_up) {
				_pick_up = new google.maps.places.Autocomplete(this, options);

				_pick_up_Lsr = google.maps.event.addListener(_pick_up, 'place_changed', function (e) {
					var results = _pick_up.getPlace();
					if (typeof results !== 'undefined' && typeof results.formatted_address !== 'undefined') {
						if (typeof results.address_components !== 'undefined') {
							for (var i = 0; i < results.address_components.length; i++) {
								if (typeof results.address_components[i]['short_name'] !== 'undefined' && (results.address_components[i]['short_name'] == 'TAS' || results.address_components[i]['types'][0] == 'administrative_area_level_1'))
									t.setState({pickup_location_state: results.address_components[i]['short_name'], pickup_location: results.formatted_address});
							}
						}
						$(pick_up_el).val(results.formatted_address);
						t.onChangePickup(results.formatted_address);

					}
					else {
						$(pick_up_el).val('');
						if (typeof t.setState === 'function')
							t.setState({pickup_locationError: 'Please select location from dropdown.'});
					}
				});
				(function pacSelectFirst(input) {
					var _addEventListener = input.addEventListener;
					function addEventListenerWrapper(type, listener) {
						// Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected
						if (type == "keydown") {
							var orig_listener = listener;
							listener = function (event) {
								var suggestion_selected = $(".pac-item-selected").length > 0;
								if ((event.which == 13 || event.which == 9) && !suggestion_selected) {
									var simulated_downarrow = $.Event("keydown", {
										keyCode: 40,
										which: 40
									});
									orig_listener.apply(input, [simulated_downarrow]);
								}
								orig_listener.apply(input, [event]);
							};
						}
						_addEventListener.apply(input, [type, listener]);
					}
					input.addEventListener = addEventListenerWrapper;
				})(this);
			}
		});

		$(pick_up_el).off('blur');
		$(pick_up_el).blur(function (e) {
			clearTimeout(pick_timeout);
			pick_timeout = setTimeout(function () {
				var results = _pick_up.getPlace();
				if (!results || typeof results.formatted_address === 'undefined' || $(pick_up_el).val() != results.formatted_address) {
					$(pick_up_el).val('');
					if (typeof t.setState === 'function')
						t.setState({pickup_locationError: 'Please select location from dropdown.'});
				}
			}, 500);
		});

		$(drop_off_el).focus(function (e) {
			$(this).data('old-value',$(this).val());
			if (!_drop_off) {
				_drop_off = new google.maps.places.Autocomplete(this, options);

				_drop_off_Lsr = google.maps.event.addListener(_drop_off, 'place_changed', function (e) {
					var results = _drop_off.getPlace();
					if (typeof results !== 'undefined' && typeof results.formatted_address !== 'undefined') {
						if (typeof results.address_components !== 'undefined') {
							for (var i = 0; i < results.address_components.length; i++) {
								if (typeof results.address_components[i]['short_name'] !== 'undefined' && (results.address_components[i]['short_name'] == 'TAS' || results.address_components[i]['types'][0] == 'administrative_area_level_1'))
									t.setState({return_location_state: results.address_components[i]['short_name'], return_location: results.formatted_address});
							}
						}
						$(drop_off_el).val(results.formatted_address);
						t.onChangeReturn(results.formatted_address);
//					interstate_steps_locations({'target': drop_off_el});
					}
					else {
						$(drop_off_el).val('');
						if (typeof t.setState === 'function')
							t.setState({return_locationError: 'Please select location from dropdown.'});
					}
				});
				(function pacSelectFirst(input) {
					var _addEventListener = input.addEventListener;
					function addEventListenerWrapper(type, listener) {
						// Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected
						if (type == "keydown") {
							var orig_listener = listener;
							listener = function (event) {
								var suggestion_selected = $(".pac-item-selected").length > 0;
								if ((event.which == 13 || event.which == 9) && !suggestion_selected) {
									var simulated_downarrow = $.Event("keydown", {
										keyCode: 40,
										which: 40
									});
									orig_listener.apply(input, [simulated_downarrow]);
								}
								orig_listener.apply(input, [event]);
							};
						}
						_addEventListener.apply(input, [type, listener]);
					}
					input.addEventListener = addEventListenerWrapper;
				})(this);
			}
		});

		$(drop_off_el).off('blur');
		$(drop_off_el).blur(function (e) {
			window.clearTimeout(drop_timeout);
			drop_timeout = setTimeout(function () {
				var results = _drop_off.getPlace();
				if (!results || typeof results.formatted_address === 'undefined' || $(drop_off_el).val() != results.formatted_address) {
					$(drop_off_el).val('');
					if (typeof t.setState === 'function')
						t.setState({return_locationError: 'Please select location from dropdown.'});
				}
			}, 500);
		});
	}
	componentDidMount() {
		if (this.props.mini_form_data === true) {

			if (this.props.booking_form_data.booking !== undefined) {
				let book_data = this.props.booking_form_data.booking;
				let set_to_state = {};

				let formats_date = ["DD-MM-YYYY", "DD/MM/YYYY", "DD/MMM/YYYY"];
				let formats_time = ["hh:mm A"];

				let _fromDate = book_data.pickup_date &&  moment(book_data.pickup_date, formats_date, true).isValid() ? moment(book_data.pickup_date, formats_date) : null,
					_fromTime =  book_data.pickup_time &&  moment(book_data.pickup_time, formats_time, true).isValid() ? moment(book_data.pickup_time, formats_time) : null,
					_toDate = book_data.return_date &&  moment(book_data.return_date, formats_date, true).isValid() ? moment(book_data.return_date, formats_date) : null,
					_toTime = book_data.return_time &&  moment(book_data.return_time, formats_time, true).isValid() ? moment(book_data.return_time, formats_time) : null;

				if (book_data.pickup_date) {
					set_to_state.fromDate = _fromDate;
					set_to_state.pickup_dateError = '';
					set_to_state.pickup_dateDirty = true;
				}
				if (book_data.pickup_time) {
					set_to_state.fromTime = _fromTime;
					set_to_state.pickup_timeError = '';
					set_to_state.pickup_timeDirty = true;
				}
				if (book_data.return_date) {
					set_to_state.toDate = _toDate;
					set_to_state.return_dateError = '';
					set_to_state.return_dateDirty = true;
				}
				if (book_data.return_time) {
					set_to_state.toTime = _toTime;
					set_to_state.return_timeError = '';
					set_to_state.return_timeDirty = true;
				}

				if (this.state.pickup_locationError.length !== 0)
					this.setState({pickup_locationDirty: true});

				if (this.state.return_locationError.length !== 0)
					this.setState({return_locationDirty: true});

				if ( !book_data.pickup_location || book_data.pickup_location.length < 4 ) {
					set_to_state.pickup_locationError = 'Please select point you will travel from.';
					set_to_state.return_timeDirty = true;
				}
				if (!book_data.return_location || book_data.return_location.length < 4 ) {
					set_to_state.return_locationError = 'Please select furthest point you will travel to.';
					set_to_state.return_locationDirty = true;
				}
				this.setState(set_to_state, this.getSearchAjax);
			}
		}

		if (this.props.scroll_to_element === 'id_search_form_interstate_div') {
			scroller.scrollTo(this.props.scroll_to_element, {
				duration: 800,
				smooth: true,
				offset: window.offset_scroll_value(),
			})
			this.props.handleSetSomeBlock('scroll_to_element', '');
		}
		_pick_up = _drop_off = null;
		this.createLocations();
	}
	componentDidUpdate(previousProps) {
		this.createLocations();

		if (this.props.category_group_filter !== previousProps.category_group_filter) {
			this.setState({category_group_filter: this.props.category_group_filter});
		}
		const firstError = document.querySelector('.has-danger');
		if (firstError) {
			const target = firstError.querySelector('input, select, textarea, [tabindex]:not([tabindex="-1"])');
			if (target) {
				scroller.scrollTo(target.id, {
					duration: 800,
					smooth: true,
					offset: window.offset_scroll_value(),
				});
				target.focus({preventScroll: true});
			}
		}
	}
	onBlurHandler(e) {
		switch (e.target.name) {
			case 'pickup_location':
				this.setState({pickup_locationDirty: true});
				break;
			case 'return_location':
				this.setState({return_locationDirty: true});
				break;
			case 'return_in_different':
				this.setState({return_in_differentDirty: true});
				break;
      		case 'interstate_email':
        		this.setState({interstate_emailDirty: true});
        		break;
			case 'interstate_phone':
				this.setState({interstate_phoneDirty: true});
				break;
		}
	}
	onChangePickup(value) {
		if (value.length) {
			if (this.state.pickup_location === this.state.return_location)
				this.setState({
					pickup_locationError: 'Please select furthest point you will travel to.',
					pickup_locationDirty: true
				});
			else {
				this.setState({return_location_show: true, pickup_locationError: ''});

				if (this.state.return_location.length)
					this.getRentalCarDistance();
			}
		}
		else
			this.setState({pickup_locationError: 'Please select point you will travel from.'});

		this.props.handleSetSearchResultInterstate(false, false, {}, {}, 0);
	}
	onChangePickupInput(e) {
		if (e.target.value.length === 0)
			this.setState({pickup_locationError: 'Please select point you will travel from.'});

		this.props.handleSetSearchResultInterstate(false, false, {}, {}, 0);
	}
	onChangeReturn(value) {
		if (value.length) {
			if (this.state.pickup_location === this.state.return_location)
				this.setState({return_locationError: 'Please select furthest point you will travel to.', return_locationDirty: true});
			else {
				this.setState({trip_show: true, return_locationError: ''});

				if(this.state.pickup_location.length)
					this.getRentalCarDistance();
			}
		}
		else
			this.setState({return_locationError: 'Please select location from dropdown.'});

		this.props.handleSetSearchResultInterstate(false, false, {}, {}, 0);
	}
	onChangeReturnInput(e) {
		if (e.target.value.length === 0)
			this.setState({return_locationError: 'Please select location from dropdown.'});

		this.props.handleSetSearchResultInterstate(false, false, {}, {}, 0);
	}
	onChangeTrip(e) {
		let value = e.target.value;
		this.setState({dates_show: true, return_in_different: value, return_in_differentError: ''});
		if(this.state.pickup_location.length && this.state.return_location.length)
			this.getRentalCarDistance();

		this.onChangeDates();

		this.props.handleSetSearchResultInterstate(false, false, {}, {}, 0);
	}
	onChangeDates() {
		//todo валидация дат и времени и после уже показать кнопку
		this.setState({button_show: true});
	}
	checkDuration() {
		if (
			this.state.toDate &&
			this.state.fromDate &&
			this.state.toTime &&
			this.state.fromTime
			&&
			!this.state.return_timeError
			&&
			!this.state.pickup_timeError
			&&
			!this.state.return_dateError
			&&
			!this.state.pickup_dateError
		) {

			let p_date = (this.state.fromDate).format('DD-MM-YYYY');
			let r_date = (this.state.toDate).format('DD-MM-YYYY');
			let p_time = (this.state.fromTime).format('hh:mm A');
			let r_time = (this.state.toTime).format('hh:mm A');

			let start = moment(p_date + ' ' + p_time, 'DD-MM-YYYY hh:mm A');
			let end = moment(r_date + ' ' + r_time, 'DD-MM-YYYY hh:mm A');

			let one_day = 24*60;
			let duration_days = moment.duration(end.diff(start)).days();
			let duration_hours = moment.duration(end.diff(start)).hours();
			let duration_minutes = moment.duration(end.diff(start)).minutes() + duration_hours * 60;

			if ( duration_days >= 1 && ( (duration_minutes > one_day && (duration_minutes % one_day) < 240) || ( duration_minutes > 1 && duration_minutes < 240 )) ) {
				this.setState({showWarning:true});
				this.props.showWarning(true);
			}
			else {
				this.setState({showWarning:false});
				this.props.showWarning(false);
			}
		}
	}
	getRentalCarDistance() {
		let params = {};
		let t = this;

		params.action = 'api/booking/get-distance';
		params.hire = this.props.booking_form_data.booking.hire;
		params.pickup_location = this.state.pickup_location;
		params.return_location = this.state.return_location;

		AJAX(bf_ajax_url, 'POST', params, {
			response_json: true,
			func_waiting: function () {
			},
			func_callback: function (resp) {
				if (resp.allowance && resp.allowance > 0) {
					if (t.props.booking_form_data.booking.hire === 'interstate') {
						let kms = resp.allowance;
						if (t.state.return_in_different == 2) {
							kms = (2 * resp.allowance);
						}

						t.setState({to_show: {kms: kms, pickup: resp.origin, return: resp.destination}});
					}
				}
				else {
					showPopupWithGoBack('Distance cannot be calculated. Please try later or call to us.');
				}

			},
			func_error: function (resp) {
				showPopupWithGoBack(resp.message);
			}
		});
	}
	callbackRentalCarPrices(resp, t) {
		let to_show = t.state.to_show;
		let prices = resp.prices;
		to_show.data_original_title = 'All vehicles come with standard insurance with Excess of $7500 in the event of an accident or claim. Reducing your excess liability coverage to $1000 for your hire period costs $' + prices.premium_insurance + ' per day.';
		to_show.insurance_cover = prices.premium_insurance;
		to_show.span_roadside_assistance = prices.roadside_assistance_price ;
		to_show.span_towing_surcharge = prices.towing_surcharge_price ;

		t.setState({to_show: to_show});
		t.props.handleSetShowData(t.state.to_show);

	}
	filterSearchResults(vehicles, t) {
		let vehicles_filtered = [];

		if (t.state.category_group_filter > 0) {
			let bf_category_categories = window.bf_category_categories;
			if (Object.keys(bf_category_categories).length > 0 && Object.keys(bf_category_categories[t.state.category_group_filter]).length > 0) {
				if (Object.keys(vehicles).length > 0) {
					let i = 0;
					Object.keys(vehicles).map((k) => {
						if (bf_category_categories[t.state.category_group_filter].includes(vehicles[k].vehiclecategoryid)) {
							vehicles_filtered[i] = vehicles[k];
							i++;
						}
					});
				}
			}
		}
		else if (t.state.category_group_filter === 0) {
			vehicles_filtered = vehicles;
		}

		let search_result_filter = {
			'vehicles': (Object.keys(vehicles_filtered).length) ? vehicles_filtered : {}
		};

		t.setState({search_result_filter: search_result_filter});
	};

	getSearchAjax() {
		window.localStorage.setItem('end_create_booking', moment().add(15, 'minutes').format("DD-MM-YYYY hh:mm:ss A"));
		window.localStorage.setItem('start_create_booking', '1');
		if (typeof window.startBooking === 'function')
			window.startBooking();
		
		let validate = true;
		let pickup_date = $('#pickup_date').val();
		if (pickup_date === undefined || (pickup_date !== undefined && pickup_date.length === 0)) {
			this.setState({pickup_dateDirty: true, validate: false});
			validate = false;
		}

		let return_date = $('#return_date').val();
		if (return_date === undefined || (return_date !== undefined && return_date.length === 0)) {
			this.setState({return_dateDirty: true, validate: false});
			validate = false;
		}

		let pickup_time = $('#pickup_time').val();
		if (pickup_time === undefined || (pickup_time !== undefined && pickup_time.length === 0)) {
			this.setState({pickup_timeError: 'This field is required.', pickup_timeDirty: true, validate: false});
			validate = false;
		}

		let return_time = $('#return_time').val();
		if (return_time === undefined || (return_time !== undefined && return_time.length === 0)) {
			this.setState({return_timeError: 'This field is required.', return_timeDirty: true, validate: false});
			validate = false;
		}

		let interstate_email = $('#interstate_email').val();
		if (interstate_email.length === 0) {
		  this.setState({interstate_emailError: 'This field is required.', interstate_emailDirty:true, validate: false});
		  validate = false;
		}
		else {
			const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
			if (!re.test(String(interstate_email).toLowerCase())) {
				this.setState({interstate_emailError: 'Please enter a valid email address.',interstate_emailDirty:true, validate: false});
				validate = false;
			}
		}

		let interstate_phone = $('#interstate_phone').val();
		if (interstate_phone.length === 0) {
		  this.setState({interstate_phoneError: 'This field is required.', interstate_phoneDirty:true, validate: false});
		  validate = false;
		}
		else {
			const re2 = /^(\+6\d{10}|0\d{9})$/;;
			if (!re2.test(interstate_phone)) {
				this.setState({interstate_phoneError: 'Please enter a valid phone number', interstate_phoneDirty:true, validate: false});
				validate = false;
			}
		}

		if ( validate && pickup_date.length > 0 && return_date.length > 0 && pickup_time.length > 0 && return_time.length > 0) {
			let selected_pickup_time = moment(pickup_date+' '+pickup_time, "DD-MM-YYYY hh:mm A");
			let selected_return_time = moment(return_date+' '+return_time, "DD-MM-YYYY hh:mm A");
			let toSet = {};

			let min_pickup_time = moment(pickup_date, "DD-MM-YYYY").add(7, 'hours').add(59, 'minutes');
			let max_pickup_time = moment(pickup_date, "DD-MM-YYYY").add(17, 'hours').add(31, 'minutes');
			if (selected_pickup_time.isBefore(max_pickup_time) && selected_pickup_time.isAfter(min_pickup_time)) {
				toSet.pickup_timeError = '';
				toSet.pickup_timeDirty = false;
				if (validate)
					toSet.validate = true;
			}
			else {
				toSet.pickup_timeError = 'Vehicle access for starting a hire is limited to between 8am to 5.30pm, to ensure vehicle accessibility at the hiring location. Please adjust your booking times accordingly.';
				toSet.pickup_timeDirty = true;
				toSet.validate = validate = false;
				toSet.showWarning = false;
			}

			if (selected_pickup_time.isBefore(moment().add(1, 'hours'))) {
				toSet.pickup_timeError = 'Vehicle access for starting a hire is limited to one hour after the current time, to ensure vehicle accessibility at the hiring location. Please adjust your booking times accordingly.';
				toSet.pickup_timeDirty = true;
				toSet.validate = validate = false;
				toSet.showWarning = false;
			}

			let min_return_time = moment(return_date, "DD-MM-YYYY").add(7, 'hours').add(59, 'minutes');
			let max_return_time = moment(return_date, "DD-MM-YYYY").add(17, 'hours').add(31, 'minutes');
			if (selected_return_time.isBefore(max_return_time) && selected_return_time.isAfter(min_return_time)) {
				toSet.return_timeError = '';
				toSet.return_timeDirty = false;
				if (validate)
					toSet.validate = true;
			}
			else {
				toSet.return_timeError = 'Vehicle access for finishing a hire is limited to between 8am to 5.30pm, to ensure vehicle accessibility at the hiring location. Please adjust your booking times accordingly.';
				toSet.return_timeDirty = true;
				toSet.validate = validate = false;
			}
			this.setState(toSet, this.validateDateTime);
		}

		if (this.state.pickup_locationError.length !== 0)
			this.setState({pickup_locationDirty: true});

		if (this.state.return_locationError.length !== 0)
			this.setState({return_locationDirty: true});

		if (this.state.return_in_differentError.length !== 0)
			this.setState({return_in_differentDirty: true});

		if ( validate && this.state.pickup_dateError.length === 0 && this.state.return_dateError.length === 0 && this.state.pickup_locationError.length === 0 && this.state.return_locationError.length === 0 && this.state.return_in_differentError.length === 0 && validate) {
			try {
				gTagClickEventValue('click_to_search_interstate', {'event_category': 'booking', 'event_label': 'booking-search'});
			}
			catch (e) {
			}
			gTagClickEventValue('click', {'event_category': 'booking', 'event_label': 'booking-search'});

			let fields = this.props.booking_field_list.get_interstate_vehicles;
			//let btn = e.target;
			let form_inputs = $('#id_interstate_search').closest('.order-data');
			let params = {};
			let form_data = {};

			let t = this;

			for (let item in fields) {
				let el = form_inputs.find('[name=' + fields[item] + ']');
				if (el.length) {
					params[fields[item]] = el[0].value.trim();
					form_data[fields[item]] = el[0].value.trim();
				}
			}
			this.setState(form_data);
			params.action = 'api/booking/get-vehicles';
			params.hire = this.props.booking_form_data.booking.hire;
			params.pickuplocationid = 185;
			params.dropofflocationid = 185;

			AJAX(bf_ajax_url, 'POST', params, {
				response_json: true,
				func_waiting: function () {
					showPreloader();
				},
				func_callback: function (resp) {
					if (resp.success === 1) {
						let search_result = t.state.search_result;
						search_result.success = resp.success;
						if (resp.vehicles !== undefined) {
							search_result.vehicles = resp.vehicles;
							t.filterSearchResults(search_result.vehicles, t);
							getRentalCarPrices(t.props.booking_form_data.booking, t.callbackRentalCarPrices, t);
						} else {
							showPopupWithGoBack('Our system currently isn\'t showing any available vehicles at that location during this time period; please contact Go With The Gecko on <a href="tel:1300 826 883">1300 826 883</a> and we will be able to help identify a quick easy solution to your booking needs.');
						}
						t.setState({search_result: search_result});

						form_data.interstate_email = t.state.interstate_email;
						form_data.interstate_phone = t.state.interstate_phone;
						form_data.pickup_location_state = t.state.pickup_location_state;
						form_data.return_location_state = t.state.return_location_state;
						t.props.handleSetSearchResultInterstate(true, false, t.state.search_result, t.state.search_result_filter, t.state.category_group_filter);
						t.props.handleSetBookingFormData(form_data, {}, {}, {});
						t.props.handleSetSomeBlock('scroll_to_element', 'id_vehicles_div');
						t.props.handleResetVehicles();
						hidePreloader();
					}
					else {
						let search_result = t.state.search_result;
						search_result.success = resp.success;
						search_result.error_limit = resp.error_limit;
						search_result.vehicles = {};
						t.setState({search_result_show: true, search_result: search_result});

						form_data.interstate_email = t.state.interstate_email;
						form_data.interstate_phone = t.state.interstate_phone;
						form_data.pickup_location_state = t.state.pickup_location_state;
						form_data.return_location_state = t.state.return_location_state;

						t.props.handleSetSearchResultInterstate(true, false, t.state.search_result, t.state.search_result_filter, t.state.category_group_filter);
						t.props.handleSetBookingFormData(form_data, {}, {}, {});
						t.props.handleResetVehicles();
						t.props.handleSetSomeBlock('scroll_to_element', 'id_vehicles_div');
						if (typeof window.stopBooking === 'function')
							window.stopBooking();
						hidePreloader();
						if (resp.message){
							showPopupWithGoBack(resp.message);
						}
						else {
							showPopupWithGoBack('Our system currently isn\'t showing any available vehicles at that location during this time period; please contact Go With The Gecko on <a href="tel:1300 826 883">1300 826 883</a> and we will be able to help identify a quick easy solution to your booking needs.');
						}
					}
				},
				func_error: function (resp) {
					if (typeof window.stopBooking === 'function')
						window.stopBooking();
					hidePreloader();
					showPopupWithGoBack(resp.message);
				}
			});
		}
		else {
			if (typeof window.stopBooking === 'function')
				window.stopBooking();
		}
	}

	onChangeVehicleGroup(e) {
		this.setState({category_group_filter: parseInt(e.target.value)});
		this.props.handleSetSearchResultInterstate(false, false, {}, {}, parseInt(e.target.value));
	}

	render() {

		let category_groups = window.bf_category_groups;
		return (<>
			<RedirectOnlyHome />
			<div id={'id_search_form_interstate_div'} className={'order-data'}>
				<div className="row">
					<div className={'col-md-8'}>
						<label className={'required'}>Pickup Location</label>
						<div className={'form-group '+((this.state.pickup_locationDirty && this.state.pickup_locationError) && 'has-danger')}>
							<i className="icon-location2"></i>
							<input
								className="form-control googlelocations pac-target-input"
								type="text"
								name="pickup_location"
								id="pickup_location_id"
								placeholder="Pickup Location"
								autoComplete="off"
								onBlur={this.onBlurHandler}
								onChange={this.onChangePickupInput}
								defaultValue={this.state.pickup_location}
							/>
							{
								(this.state.pickup_locationDirty && this.state.pickup_locationError) &&
								<small className="form-control-feedback d-block">{this.state.pickup_locationError}</small>
							}
						</div>
					</div>
					<div className={'col-md-8'}>
						{
							this.state.return_location_show &&
							<>
								<label className={'required'}>Furthest Point You Will Travel To</label>
								<div className={'form-group '+((this.state.return_locationDirty && this.state.return_locationError) && 'has-danger')}>
									<i className="icon-location2"></i>
									<input
										className="form-control googlelocations interstatelocations pac-target-input"
										type="text"
										name="return_location"
										id="return_location_id"
										placeholder="Furthest Point You Will Travel To"
										autoComplete="off"
										onBlur={this.onBlurHandler}
										onChange={this.onChangeReturnInput}
										defaultValue={this.state.return_location}
									/>
								{
									(this.state.return_locationDirty && this.state.return_locationError) &&
									<small className="form-control-feedback d-block">{this.state.return_locationError}</small>
								}
							</div>
							</>
						}
					</div>
					{
						this.state.trip_show &&
						<div className="col-md-4 one_way">
								<label className={'required'}>Select a Trip Type</label>
								<div className={'form-group '+((this.state.return_in_differentDirty && this.state.return_in_differentError) && 'has-danger')}>
									<i className="icon-route"></i>
									<select className="form-control recalculate-order required"
											name="return_in_different"
											id="return_in_different"
											onChange={this.onChangeTrip}
											value={this.state.return_in_different}
											onBlur={this.onBlurHandler}>
										<option value="0" disabled={true}>Select a trip</option>
										<option value="1">One way trip</option>
										<option value="2">Return Trip</option>
									</select>
									{
										(this.state.return_in_differentDirty && this.state.return_in_differentError) &&
											<small className="form-control-feedback d-block">{this.state.return_in_differentError}</small>
									}
								</div>
							</div>
					}
				</div>
				{
					this.state.dates_show &&
					<>
						<div className="row">
							<div className={'col-md-3'}>
								<label className={'required'}>Pickup Date</label>
								<div className={'form-group '+((this.state.pickup_dateDirty && this.state.pickup_dateError) && 'has-danger')}>
								<DateComponent
									minDate={getCurrentMinDate()}
									name={"pickup_date"}
									placeholder={"Pickup date"}
									key={'from_local'}
									defaultDate={getCurrentMinDate()}
									setDate={this.state.fromDate}
									onChange={this.fromDateChange}
									value={this.props.booking_form_data.booking.pickup_date}
								/>

								{
									(this.state.pickup_dateDirty && this.state.pickup_dateError) &&
									<small className="form-control-feedback d-block">{this.state.pickup_dateError}</small>
								}
							</div>
							</div>
							<div className={'col-md-3'}>
								<label className={'required'}>Pickup Time</label>
								<div className={'form-group '+((this.state.pickup_timeDirty && this.state.pickup_timeError) && 'has-danger')}>
									<TimeComponent
										key={`${this.state.fromDate}`}
										setTime={this.state.fromTime}
										defaultDate={this.getDefaultStartTime()}
										disabledHours={this.getDisabledHours()}
										name={"pickup_time"}
										placeholder={"Pickup time"}
										onChange={this.fromTimeChange}
										value={this.props.booking_form_data.booking.pickup_time}
									/>
									{
										(this.state.pickup_timeDirty && this.state.pickup_timeError) &&
										<small className="form-control-feedback d-block">{this.state.pickup_timeError}</small>
									}
								</div>
							</div>
							<div className={'col-md-3'}>
								<label className={'required'}>Return Date</label>
								<div className={'form-group '+((this.state.return_dateDirty && this.state.return_dateError) && 'has-danger')}>
								<DateComponent
									minDate={ this.state.fromDate ? this.state.fromDate.clone().subtract(1, 'day') : null }
									name={"return_date"}
									placeholder={"Return date"}
									key={'to_local'}
									defaultDate={this.getDefaultEndDate()}
									setDate={this.state.toDate}
									onChange={this.toDateChange}
									value={this.props.booking_form_data.booking.return_date}
								/>
								{
									(this.state.return_dateDirty && this.state.return_dateError) &&
									<small className="form-control-feedback d-block">{this.state.return_dateError}</small>
								}
							</div>
							</div>
							<div className={'col-md-3'}>
								<label className={'required'}>Return Time</label>
								<div className={'form-group '+((this.state.return_timeDirty && this.state.return_timeError) && 'has-danger')}>
								    <TimeComponent
									key={`${this.state.fromDate}-${this.state.fromTime}`}
									setTime={this.state.toTime}
									defaultDate={ this.getDefaultEndTime() }
									disabledHours={ this.getDisabledHoursReturn() }
									name={"return_time"}
									placeholder={"Return time"}
									onChange={this.toTimeChange}
									value={this.props.booking_form_data.booking.return_time}
									/>
								{
									(this.state.return_timeDirty && this.state.return_timeError) &&
									<small className="form-control-feedback d-block">{this.state.return_timeError}</small>
								}
							</div>
							</div>
						</div>

						<div className="row">
							<div className={'col-md-6'}>
								<label>Promo Code</label>
								<div className="form-group">
									<i className="icon2-coupon"></i>
									<input className="form-control" autoComplete="off" type="text" defaultValue={this.state.campaigncode}
										   name="campaigncode" placeholder="Promo-Code if any..." />
								</div>
							</div>
							<div className={'col-md-6'}>
								<label>Select Vehicle</label>
								<div className="form-group">
									<i className="icon3-sports-car"></i>
									<select className="form-control"
											name="category_group"
											onChange={this.onChangeVehicleGroup}
											value={this.state.category_group_filter}>
										<option value="0" key="0"></option>
										{Object.keys(category_groups).map((keyName) => (
											<option value={category_groups[keyName]} key={category_groups[keyName]}>{keyName}</option>
										))}
									</select>
								</div>
							</div>
						</div>
            			<div className="row">
							<div className={'col-md-6'}>
								<label className={'required'}>Your Email</label>
								<div className= {'form-group ' + (( this.state.interstate_emailDirty && this.state.interstate_emailError) && 'has-danger')}>
									<span className="icon-email">
									   <svg className="icon-email-svg" viewBox="0 0 32 32">
										  <path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM8 8h16c0.286 0 0.563 0.061 0.817 0.177l-8.817 10.286-8.817-10.287c0.254-0.116 0.531-0.177 0.817-0.177zM6 22v-12c0-0.042 0.002-0.084 0.004-0.125l5.864 6.842-5.8 5.8c-0.045-0.167-0.069-0.34-0.069-0.517zM24 24h-16c-0.177 0-0.35-0.024-0.517-0.069l5.691-5.691 2.826 3.297 2.826-3.297 5.691 5.691c-0.167 0.045-0.34 0.069-0.517 0.069zM26 22c0 0.177-0.024 0.35-0.069 0.517l-5.8-5.8 5.865-6.842c0.003 0.041 0.004 0.083 0.004 0.125v12z"></path>
									   </svg>
									</span>
									<input
										className="form-control required"
										type="email"
										placeholder="Email *"
										autoComplete="off"
										name="interstate_email"
										id="interstate_email"
										onChange={this.onChangeEmailInput}
										onBlur={this.onBlurHandler}
										defaultValue={this.state.interstate_email}
									/>

									{
										( this.state.interstate_emailDirty && this.state.interstate_emailError) &&
										<small className="form-control-feedback d-block">{this.state.interstate_emailError}</small>
									}
								</div>
							</div>
							<div className={'col-md-6'}>
								<label className={'required'}>Your Phone</label>
								<div className= {'form-group ' + (( this.state.interstate_phoneDirty && this.state.interstate_phoneError) && 'has-danger')}>
									<span className="icon-phone">
										<svg  className="icon-phone-svg" viewBox="0 0 16 16">
											<path d="M11 10c-1 1-1 2-2 2s-2-1-3-2-2-2-2-3 1-1 2-2-2-4-3-4-3 3-3 3c0 2 2.055 6.055 4 8s6 4 8 4c0 0 3-2 3-3s-3-4-4-3z"></path>
										</svg>
									</span>
									<input
										className="form-control required"
										type="text"
										placeholder="Phone *"
										autoComplete="off"
										name="interstate_phone"
										id="interstate_phone"
										onChange={this.onChangeEmailInput}
										onBlur={this.onBlurHandler}
										defaultValue={this.state.interstate_phone}
									/>
									{
										( this.state.interstate_phoneDirty && this.state.interstate_phoneError) &&
										<small className="form-control-feedback d-block">{this.state.interstate_phoneError}</small>
									}
								</div>
							</div>
            			</div>
						<div className="row">
							<div className="form-group col-md-12">
								{ this.state.showWarning &&  <p style={{color:"#d63545",margin:"0",marginBottom:"5px",fontSize:"14px"}}>Gecko Money Saving Tip: Decreasing your booking length can help you save money on daily charges.</p>}
							</div>
						</div>
					</>
				}
				{
					this.state.button_show &&
					<div className="row">
						<div className="col">
							<input type="button" value="Search" className="btn btn-red" id="id_interstate_search" onClick={this.getSearchAjax} />
						</div>
					</div>
				}
			</div>
		</>);
	}

	fromDateChange = (date) => {
		if(date === null) {
			this.setState({fromDate: null});
		}
		else {
			let toSet = {fromDate: date, validate: false};
			if (this.state.toDate === null) {
				toSet.pickup_dateError = '';
				toSet.return_dateError = '';
				toSet.pickup_dateDirty = false;
				toSet.return_dateDirty = false;
			}
			else {
				let date_pickup = new Date(date.format('YYYY-MM-DD')).getTime();
				let date_return = new Date(this.state.toDate.format('YYYY-MM-DD')).getTime();
				if( date_return < date_pickup ) {
					toSet.toDate = null;
					toSet.return_dateError = 'Date must be after start date';
					toSet.return_dateDirty = true;
				}
				else {
					if (date_return == date_pickup ) {
						if (this.state.fromTime !== null && this.state.toTime !== null &&  this.state.toTime.hour() <= this.state.fromTime.hour()){
							toSet.return_dateError = 'Date must be after start date';
							toSet.return_dateDirty = true;
						}
					}
					else{
						toSet.pickup_dateError = '';
						toSet.return_dateError = '';
						toSet.pickup_dateDirty = false;
						toSet.return_dateDirty = false;
					}
				}
			}
			if ( !toSet.pickup_dateError && !toSet.return_dateError && this.state.fromDate !== null && date.format('DD-MM-YYYY') !== this.state.fromDate.format('DD-MM-YYYY')) {
				const two_days = moment(new Date()).add(2, 'days');
				let p_time = "08:00 AM";
				if ($('#pickup_time').val()) {
					p_time = $('#pickup_time').val();
				}
				if ($('#pickup_date').val()) {
					let pickup_date = moment($('#pickup_date').val() + ' ' + p_time, 'DD-MM-YYYY hh:mm A');
					if (pickup_date.isBefore(two_days)) {
						if (this.state.first_open_calendar) {
							showPopupWithGoBack('Due to the immediate nature of your booking, please contact Go With The Gecko on 1300 826 883 so we can help you out as best as possible.');
							toSet.pickup_dateError = 'Check dates';
							toSet.pickup_dateDirty = true;
						} else {
							toSet.first_open_calendar = true;
						}
					}
				}
			}
			this.setState(toSet, this.validateDateTime);
		}
		this.props.handleSetSearchResultInterstate(false, false, {}, {}, 0);
	}
	toDateChange = (date) => {
		if (date === null) {
			this.setState({toDate: null});
		}
		else {
			let toSet = {toDate: date, validate: false};
			if(this.state.fromDate !== null) {
				let date_pickup = new Date(this.state.fromDate.format('YYYY-MM-DD')).getTime();
				let date_return = new Date(date.format('YYYY-MM-DD')).getTime();
				if (date_return < date_pickup) {
					toSet.toDate = null;
					toSet.return_dateError = 'Date must be after start date';
					toSet.return_dateDirty = true;
				}
				else {
					if (date_return == date_pickup ) {
						if (this.state.fromTime !== null && this.state.toTime !== null &&  this.state.toTime.hour() <= this.state.fromTime.hour()){
							toSet.return_dateError = 'Date must be after start date';
							toSet.return_dateDirty = true;
						}
					}
					else{
						toSet.pickup_dateError = '';
						toSet.return_dateError = '';
						toSet.pickup_dateDirty = false;
						toSet.return_dateDirty = false;
					}
				}
			}
			else {
				toSet.return_dateError = '';
				toSet.return_dateDirty = false;
			}
			this.setState(toSet, this.validateDateTime);
		}
		this.props.handleSetSearchResultInterstate(false, false, {}, {}, 0);
	}
	fromTimeChange = (date) => {
		if (date === null) {
			this.setState({fromTime: null});
		} else {
			let toSet = {fromTime: date, pickup_timeError: '', pickup_timeDirty: false, validate: false};
			const { fromDate, toDate, toTime } = this.state;
			if (fromDate && toDate && toTime) {
				const pickupDateTime = fromDate.clone().set({
					hour: date.hour(),
					minute: date.minute()
				});
				const returnDateTime = toDate.clone().set({
					hour: toTime.hour(),
					minute: toTime.minute()
				});
				if (!returnDateTime.isAfter(pickupDateTime)) {
					toSet.return_dateError = 'Date must be after start date';
					toSet.return_dateDirty = true;
				} else {
					toSet.return_dateError = '';
					toSet.return_dateDirty = false;
				}
			}
			else {
				toSet.return_dateError = '';
				toSet.return_dateDirty = false;
			}
			this.setState(toSet, this.validateDateTime);
		}
		this.props.handleSetSearchResultInterstate(false, false, {}, {}, 0);
	}
	toTimeChange = (date) => {
		if (date === null) {
			this.setState({toTime: null});
		}
		else {
			let toSet = {toTime: date, return_timeError: '', return_timeDirty: false, validate: false};
			const {fromDate, toDate, fromTime} = this.state;
			if (fromDate && toDate && fromTime) {
				const pickupDateTime = fromDate.clone().set({
					hour: fromTime.hour(),
					minute: fromTime.minute()
				});
				const returnDateTime = toDate.clone().set({
					hour: date.hour(),
					minute: date.minute()
				});

				if (!returnDateTime.isAfter(pickupDateTime)) {
					toSet.return_dateError = 'Date must be after start date';
					toSet.return_dateDirty = true;
				} else {
					toSet.return_dateError = '';
					toSet.return_dateDirty = false;
				}
			} else {
				toSet.return_dateError = '';
				toSet.return_dateDirty = false;
			}
			this.setState(toSet, this.validateDateTime);
		}
		this.props.handleSetSearchResultInterstate(false, false, {}, {}, 0);
	}

	getDefaultStartTime = () => getDefaultStartTime(this.state.fromDate);
	getDefaultEndDate =  () =>  getDefaultEndDate(this.state.fromDate, 'interstate');
	getDefaultEndTime =  () =>  getDefaultEndTime(this.state.fromTime, this.state.fromDate);
	getDisabledHours =  () => getDisabledHours(this.state.fromDate, this.state.fromTime,false);
	getDisabledHoursReturn =  () => getDisabledHours(this.state.fromDate, this.state.fromTime,true, this.state.toDate);

	validateDateTime = () => {
		let { fromDate, toDate, fromTime, toTime } = this.state;
		if (!fromDate || !toDate || !fromTime || !toTime) return;
		let startDateTime = fromTime ? fromDate.clone().set({ hour: fromTime.hour(), minute: fromTime.minute() }) : fromDate.clone().set({ hour: 0, minute: 0 });
		let mindate = moment().add(50, 'minutes');
		if (!startDateTime.isAfter(mindate)) {
			this.setState({
				pickup_dateError: 'Start date and time must be at least one hour ahead of the current time.',
				pickup_dateDirty: true
			});
		}
		else {
			this.setState({
				pickup_dateError: '',
				pickup_dateDirty: false
			});
		}
		let endDateTime = toTime ? toDate.clone().set({ hour: toTime.hour(), minute: toTime.minute() }) : toDate.clone().set({ hour: 0, minute: 0 });
		if (!endDateTime.isAfter(startDateTime)) {
			this.setState({
				return_dateError: 'End date and time must be after start date and time',
				return_dateDirty: true
			});
		}
		else {
			this.setState({
				return_dateError: '',
				return_dateDirty: false
			});
		}
		this.checkDuration();
	};
}

export default SearchFormInterstatePage;
